export const AddTitle = {
    title: 'Thêm chuyến vận chuyển',
};

export const EditTitle = {
    title: 'Chỉnh sửa chuyến vận chuyển',
};

export const GroupedDeliveryTrips = {
    title: 'Nhóm chuyến vận chuyển',
};

export const DeliveryStatistics = {
    title: 'Thống kê vận chuyển',
};

export const deliveryTripBarChartCategories = ["Thùng", "Cơ Khí Ô Tô", "Phuy"]

export const deliveryTripBarChartColors = {
    "Thùng": "#60a5fa",
    "Cơ Khí Ô Tô": "#8b5cf6",
    "Phuy": "#ec4899",
};

export const deliveryTripBarChartStatusGroups = ["Đã vận chuyển", "Không thành công", "Đang vận chuyển"];

export const deliveryTripsSummaryUrl = "/delivery-trips/summary/";